import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["id", "className", "theme", "type", "closable", "closed", "closeText", "onClose", "showIcon", "icon", "title", "children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { css } from '@jd/jmtd-tools/es/css';
import ResizeObserver from 'resize-observer-polyfill';
import Icon from '../Icon';
var typeInfo = {
  default: 'jmti-info-circle-f',
  success: 'jmti-check-circle-f',
  info: 'jmti-info-circle-f',
  help: 'jmti-info-triangle-f',
  danger: 'jmti-exclamation-circle-f',
  warning: 'jmti-info-circle-f'
};

var Alert = /*#__PURE__*/function (_PureComponent) {
  _inherits(Alert, _PureComponent);

  var _super = _createSuper(Alert);

  function Alert() {
    _classCallCheck(this, Alert);

    return _super.apply(this, arguments);
  }

  _createClass(Alert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      this.ro = new ResizeObserver(function () {
        _this.resize();
      });
      this.ro.observe(this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.resize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ro && this.ro.disconnect();
    }
  }, {
    key: "resize",
    value: function resize() {
      var ref = this.ref;
      css(ref, 'max-height', "".concat(ref.scrollHeight, "px"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          theme = _this$props.theme,
          type = _this$props.type,
          closable = _this$props.closable,
          closed = _this$props.closed,
          closeText = _this$props.closeText,
          onClose = _this$props.onClose,
          showIcon = _this$props.showIcon,
          icon = _this$props.icon,
          title = _this$props.title,
          children = _this$props.children,
          other = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement("div", _extends({
        ref: function ref(_ref) {
          _this2.ref = _ref;
        },
        id: id,
        className: classNames('jmtd-alert', className, "jmtd-alert-".concat(theme), "jmtd-alert-type-".concat(type), {
          'jmtd-alert-hide': closed
        })
      }, other), showIcon && /*#__PURE__*/React.createElement("div", {
        className: "jmtd-alert-icon-wrapper"
      }, icon || /*#__PURE__*/React.createElement(Icon, {
        size: "small",
        className: classNames('jmtd-alert-icon', typeInfo[type])
      })), /*#__PURE__*/React.createElement("div", {
        className: "jmtd-alert-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-alert-title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "jmtd-alert-description"
      }, children)), closable && /*#__PURE__*/React.createElement("div", {
        className: "jmtd-alert-operate-close",
        onClick: onClose
      }, closeText || /*#__PURE__*/React.createElement(Icon, {
        size: "small",
        className: "jmti-close"
      })));
    }
  }]);

  return Alert;
}(PureComponent);

Alert.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.string,
  type: PropTypes.oneOf(['default', 'success', 'info', 'warning', 'danger', 'help']),
  closable: PropTypes.bool,
  closed: PropTypes.bool,
  closeText: PropTypes.node,
  onClose: PropTypes.func,
  showIcon: PropTypes.bool,
  icon: PropTypes.node,
  title: PropTypes.node,
  children: PropTypes.node
};
Alert.defaultProps = {
  id: null,
  className: '',
  theme: 'light',
  type: 'default',
  closable: false,
  closed: false,
  closeText: '',
  onClose: function onClose() {},
  showIcon: true,
  icon: null,
  title: '',
  children: null
};
export default Alert;